import Box from '@material-ui/core/Box';
import React from 'react';
import HistoryEventTypes from '../../../../../constants/HistoryEventTypes';
import { DoorHistoryFragment } from '../../../../../queries';
import DoorHistoryDetailDialog from '../DoorHistoryDetailDialog';
import StandardGridItem from './StandardGridItem';
import { Grid } from '@material-ui/core';

interface AdditionalInfo {
  note?: string;
}

interface DoorUpdatedDetailDialogProps {
  open: boolean;
  onClose: () => void;
  history: DoorHistoryFragment;
}

interface DetailDialogProps {
  history: DoorHistoryFragment;
  isPass: boolean;
}

function DetailDialog({ history }: DetailDialogProps) {
  if (!history.additionalInfoJson) {
    return <></>;
  }

  const additionalInfo = JSON.parse(history.additionalInfoJson) as AdditionalInfo;
  return (
    <Box pt={1} pb={1}>
      <Grid container spacing={3}>
        <StandardGridItem title={'Note'} value={additionalInfo.note} minWidth={12} />
      </Grid>
    </Box>
  );
}

export default function DoorNoteAddedDetailDialog({ open, onClose, history }: DoorUpdatedDetailDialogProps) {
  const isPass = history.historyEventType.code === HistoryEventTypes.DoorInspectionPassed;
  return (
    <DoorHistoryDetailDialog open={open} onClose={onClose} history={history} actorName={'Added by'}>
      <DetailDialog history={history} isPass={isPass} />
    </DoorHistoryDetailDialog>
  );
}
